import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { SecurityDetailsComponent } from './components/security-details/security-details.component';
import { UpsertGeneralRatesComponent } from './components/upsert-general-rates/upsert-general-rates.component';
import { UpsertSpecificAdviceComponent } from './components/upsert-specific-advice/upsert-specific-advice.component';

const routes: Routes = [
  {
    path: '',
    component: PortfolioComponent,
  },
  {
    path: 'add-general-rates',
    component: UpsertGeneralRatesComponent,
  },
  {
    path: 'add-specific-advice',
    component: UpsertSpecificAdviceComponent,
  },
  {
    path: ':securityId/edit-general-rates',
    component: UpsertGeneralRatesComponent,
  },
  {
    path: ':securityId/edit-specific-advice',
    component: UpsertSpecificAdviceComponent,
  },
  {
    path: ':id/details',
    component: SecurityDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortfolioRoutingModule {}
